import storage from 'tools/localstorage/localStorage';
import { ABTestingScenarios } from './TestingScenarios';

export type Scenario = { scenario: string };

export const ABTestingKeys = {
  Pricing: 'pricing.scenario',
  StockShortage: 'stockShortage.scenario',
  LandingPage: 'landingPage.scenario' // Used by multiple ab tests about the landing page - it's timeframe
} as const;

// Use this part of the store to store the selected variants of A/B tests.
// This way it's easy to show/hide or enable/disable certain parts at any location
// of the application for tests.
export type ABTesting = {
  pricing: Scenario;
  stockShortage: Scenario;
  landingPage: Scenario;
};

const initialABTesting: ABTesting = {
  pricing: {
    scenario: ABTestingScenarios.Pricing.Default
  },
  stockShortage: {
    scenario: ABTestingScenarios.StockShortage.A
  },
  landingPage: {
    scenario: ABTestingScenarios.LandingPage.Default
  }
};

export const setABTestingPricingScenario = (value: string) => {
  storage.setABTestingValue(ABTestingKeys.Pricing, value);
};

export const setABTestingStockShortageScenario = (value: string) => {
  storage.setABTestingValue(ABTestingKeys.StockShortage, value);
};

export const getABTestingObject = () => {
  return {
    pricing: {
      scenario: storage.getABTestingValue(ABTestingKeys.Pricing)
    },
    stockShortage: {
      scenario: storage.getABTestingValue(ABTestingKeys.StockShortage)
    },
    landingPage: {
      scenario: storage.getABTestingValue(ABTestingKeys.LandingPage)
    }
  } as ABTesting;
};

export const getABTestingScenario = (
  scenarioKey: (typeof ABTestingKeys)[keyof typeof ABTestingKeys]
) => {
  return storage.getABTestingValue(scenarioKey);
};

// True only if any localStorage value is (still) unset.
export const ABTestingScenarioIsUnset = () => {
  const o = getABTestingObject();
  return ![o.pricing.scenario, o.stockShortage.scenario].reduce(
    (isUnset, currentValue) => isUnset && !!currentValue,
    true
  );
};

export const setABTestingScenarioDefault = () => {
  setABTestingPricingScenario(initialABTesting.pricing.scenario);
  setABTestingStockShortageScenario(initialABTesting.stockShortage.scenario);
};
